import React from "react";
import styled from "styled-components";

export const Loading = () => {
    return <Load><img src={`${process.env.REACT_APP_CDN_IMG}/img_static/img_pres/_v5/happy_loading_5.gif`} alt="" width="60" height="69" /></Load>
}

const Load = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 295px;
    margin: 0 0 50px;
`



// WEBPACK FOOTER //
// ./src/estimate_list/common/loadingComponent.js